import RestorePasswordPage from './RestorePasswordPage.vue'

export default {
    routers() {
        return [
            {
                path: '/user/restorepassword',
                name: 'userRestorePassword',
                component: RestorePasswordPage
            },
        ];
    }
}


// WEBPACK FOOTER //
// ./src/components/user/src/Router.js